const Emoji_QR = {
    ':question': { id: 400, width: 19, height: 19 },
    ':question1': { id: 399, width: 20, height: 20 },
    ':ranting_w': { id: 401, width: 28, height: 24 },
    ':rasta': { id: 402, width: 30, height: 27 },
    ':red_bandana': { id: 403, width: 23, height: 19 },
    ':red_indian': { id: 405, width: 24, height: 29 },
    ':redface': { id: 404, width: 16, height: 16 },
    ':renske': { id: 406, width: 18, height: 18 },
    ':respect': { id: 407, width: 44, height: 22 },
    ':respekt': { id: 408, width: 43, height: 18 },
    ':retard': { id: 29, width: 26, height: 18 },
    ':rev': { id: 409, width: 40, height: 25 },
    ':rinoa': { id: 410, width: 45, height: 33 },
    ':rip': { id: 411, width: 20, height: 20 },
    ':rock_on': { id: 596, width: 32, height: 18 },
    ':rofl': { id: 412, width: 46, height: 18 },
    ':roflz': { id: 598, width: 30, height: 18 },
    ':rolleyes': { id: 10, width: 20, height: 20 },
    ':rose': { id: 65, width: 18, height: 18 },
    ':rotate': { id: 414, width: 15, height: 15 },
    ':row': { id: 415, width: 36, height: 15 },
    ':rupor': { id: 416, width: 38, height: 18 },
}

export default Emoji_QR
